<template>
  <b-card
    no-body
    tag="article"
    class="mb-3 mr-3"
    header-bg-variant="danger"
  >
    <h4 slot="header" class="mb-0">
      <i class="fas fa-exclamation-circle"></i>
      <span class="pl-2">{{alert.rule.label}}</span>
    </h4>
    <b-card-body>
      <p class="card-text">
        <table class="table alert-table table-sm">
          <tbody>
            <tr>
              <th scope="row">Device</th>
              <td>{{ alert.device.name }}</td>
            </tr>
            <tr>
              <th scope="row">Location / Site</th>
              <td>{{ alert.device.site.name }}</td>
            </tr>
            <tr>
              <th scope="row">Alert Count</th>
              <td>{{ alert.count }}</td>
            </tr>
            <tr>
              <th scope="row">First Seen</th>
              <td>{{ formatDate(alert.firstSeen) }}</td>
            </tr>
            <tr>
              <th scope="row">Last Seen</th>
              <td>{{ formatDate(alert.lastSeen) }}</td>
            </tr>
            <tr>
              <th scope="row">Next Reminder</th>
              <td>{{ formatDate(alert.nextReminder) }}</td>
            </tr>
            <tr>
              <th scope="row">Message</th>
              <td>{{ alert.message }}</td>
            </tr>
          </tbody>
        </table>

        <b-button @click.stop="processAlert('snooze')" size="sm" variant="info" class="mr-1"><i class="fas fa-clock"></i><span class="pl-2">Snooze</span></b-button>
        <b-button @click.stop="processAlert('acknowledge')" v-if="alert.id" size="sm" variant="success" class="mr-1 float-right"><i class="fas fa-check"></i><span class="pl-2">Acknowledge</span></b-button>
      </p>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment-timezone'
import { UPDATE_ALERT_SUMMARY_MUTATION } from '@/constants/graphql'

export default {
  name: 'AlertCard',
  props: {
    alert: {
      type: Object,
      default () {
        return {
          id: null,
          rule: {
            label: null
          },
          device: {
            name: null,
            site: {
              name: null
            }
          }
        }
      }
    }
  },
  data () {
    return {
      loading: 0,
      error: null,
      methodOptions: [
        { value: null, text: 'Please select a method' },
        { value: 'EMAIL', text: 'Email' },
        { value: 'SMS', text: 'Text Message' }
      ]
    }
  },
  computed: {
  },
  methods: {
    formatDate (dateString) {
      if (dateString) {
        return moment(dateString, 'YYYY-MM-DD HH:mm:ss Z').format('ddd, MMM Do YYYY, h:mma')
      }
      return '-'
    },
    processAlert (method) {
      method = method || 'snooze'
      let displayText = method.charAt(0).toUpperCase() + method.substr(1)

      this.$swal.fire({
        title: `${displayText} this alert?`,
        icon: 'warning',
        toast: false,
        position: 'top',
        showConfirmButton: true,
        timer: 0,
        timerProgressBar: false,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, ${displayText} it!`
      }).then((result) => {
        if (result.isConfirmed) {
          let data = {}
          // snooze
          if (method == 'snooze') {
            data.nextReminder = moment().add(this.alert.rule.reminderInterval, 'seconds')
          } else {
            data.acknowledged = true
          }

          this.$apollo.mutate({
            mutation: UPDATE_ALERT_SUMMARY_MUTATION,
            variables: { data, id: this.alert.id }
          }).then(() => {
            this.$swal.fire({ icon: 'success', title: `Success! Alert ${displayText}d` })
            this.$emit('processed')
          }).catch(() => {
            // handled by global onError handler but still need to catch in the promise
          })

        }
      })
    }
  }
}
</script>

<style>
table.alert-table tbody tr:first-child td, table.alert-table tbody tr:first-child th {
  border-top: none !important;
}
.card-header h4 {
    font-size: 1.2em;
    line-height: 1.2em;
}
article.card {
  width: 22rem;
  min-width: 20rem;
  max-width: 25rem;
}
article.card {
  background-color: rgba(255,255,255, 0.9);
}
</style>
